module.exports = __webpack_public_path__ + "img/画板 1@3x.32554265.png";